import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHorizontalAlignCenter = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 1.75v16.5M12.75 10h5.5m-5.5 0 3-3.25m-3 3.25 3 3.25M7.25 10h-5.5m5.5 0-3-3.25m3 3.25-3 3.25"
	})]
});
const ForwardRef = forwardRef(SvgHorizontalAlignCenter);
export { ForwardRef as ReactComponent };
